import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Schede from './components/Schede';
import Fatture from './components/Fatture';
import Contratti from './components/Contratti';
import Siti from './components/Siti';
import Clienti from './components/Clienti';

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/" element={<Login />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/schede" element={<Schede />} />
                <Route path="/fatture" element={<Fatture />} />
                <Route path="/contratti" element={<Contratti />} />
                <Route path="/siti" element={<Siti />} />
                <Route path="/clienti" element={<Clienti />} />
            </Routes>
        </Router>
    );
}

export default App;
